import { useVmSizeCheck } from '@/hooks/useVmSizeCheck'
import { DB_RECOMMENDED_NOTE } from '@/data/sizeCatalog'
import { useDeploymentWizard } from '@/stores/deploymentWizard'
import { useInfrastructureWizard } from '@/stores/infrastructureWizard'
import { usesPoolTiers } from '@/utils/sizing'
import { VmSpecCard } from './VmSpecCard'

/**
 * The DB VM of a NEW SQL VM. Put it where a new SQL VM is being created and nowhere else: an existing server shows its own details instead,
 * and an Azure SQL (PaaS) server is not sized. The size is fixed and the user cannot choose it: for now it is the largest DB size the catalog
 * had, and the card says "Recommended size, not confirmed". Where the region does not offer it, the nearest series of the same size is shown
 * (and built) instead, with a notice. `requiredIps` is the number of RDS VMs, which the size check shares with the RDS VM card's; left out,
 * it is the number the user chose.
 */
export function DbVmSizeCard({ requiredIps }: { requiredIps?: number }) {
  const product = useInfrastructureWizard((s) => s.product)
  const poolTier = useDeploymentWizard((s) => s.poolTier)
  const sizes = useVmSizeCheck(requiredIps)
  if (!usesPoolTiers(product)) return null
  return (
    <VmSpecCard
      kind="db"
      poolTier={poolTier}
      title="Database VM size"
      note={`${DB_RECOMMENDED_NOTE}: it is the same for every pool tier and cannot be set here.`}
      check={sizes.db}
      checkNote={sizes.note}
    />
  )
}
